import { gql } from "@apollo/client";

const unclaimOrderProductionJobCustomizationAreaMutation = gql`
  mutation($orderProductionJobCustomizationAreaId: ID!) {
    unclaimOrderProductionJobCustomizationArea(
      orderProductionJobCustomizationAreaId: $orderProductionJobCustomizationAreaId
    ) {
      errors {
        orderProductionJobCustomizationAreaId
      }
      succeeded
      updatedOrderProductionJobCustomizationArea {
        id
      }
    }
  }
`;

export default unclaimOrderProductionJobCustomizationAreaMutation;
